import React, { useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import AnalogyCard from '../components/AnalogyCard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { allAnalogies } from '../mock';
import SEO, { generateBreadcrumbSchema } from '../components/SEO';
import AdSense from '../components/AdSense';

const Analogies = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const cspAnalogies = allAnalogies.filter((a) => a.category === 'CSP');
  const ccAnalogies = allAnalogies.filter((a) => a.category === 'CC');

  return (
    <div className="min-h-screen">
      <SEO
        title="Options Trading Analogies: Understand Complex Strategies Simply"
        description="Browse 12 proven analogies that make options trading click. Insurance, real estate, warranties—map complex strategies to familiar concepts."
        keywords="options trading analogies, options explained simply, understand options trading, options for beginners, CSP analogies, covered call analogies"
        canonical="https://optionsanalogies.com/analogies"
        type="website"
        schema={[
          generateBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Analogies Library", path: "/analogies" }
          ])
        ]}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Breadcrumb items={[{ label: 'Analogies Library', path: '/analogies' }]} />

        {/* Header - Ad-Free Zone */}
        <div className="mb-12" data-nosnippet>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Analogies Library</h1>
          <p className="text-xl text-gray-300">
            Browse all analogies with stories, pros, cons, and formulas. Each analogy maps options mechanics to familiar contracts.
          </p>
        </div>

        {/* Ad Placement 1 - After Tabs */}
        <div className="mb-8">
          <AdSense slot="1426603633" format="horizontal" />
        </div>

        {/* Tabs */}
        <Tabs defaultValue="all" className="mb-8" onValueChange={setActiveCategory}>
          <TabsList className="bg-gray-900/50 border border-gray-800">
            <TabsTrigger value="all" className="data-[state=active]:bg-emerald-600">
              All Analogies ({allAnalogies.length})
            </TabsTrigger>
            <TabsTrigger value="csp" className="data-[state=active]:bg-emerald-600">
              CSP ({cspAnalogies.length})
            </TabsTrigger>
            <TabsTrigger value="cc" className="data-[state=active]:bg-emerald-600">
              Covered Calls ({ccAnalogies.length})
            </TabsTrigger>
          </TabsList>

          <TabsContent value="all" className="mt-8">
            <div className="grid md:grid-cols-2 gap-6">
              {allAnalogies.slice(0, 6).map((analogy) => (
                <AnalogyCard key={analogy.id} analogy={analogy} />
              ))}
            </div>
            {/* Ad Placement 2 - Mid Content */}
            <div className="my-8">
              <AdSense slot="8031540436" format="rectangle" />
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {allAnalogies.slice(6).map((analogy) => (
                <AnalogyCard key={analogy.id} analogy={analogy} />
              ))}
            </div>
          </TabsContent>

          <TabsContent value="csp" className="mt-8">
            <div className="grid md:grid-cols-2 gap-6">
              {cspAnalogies.map((analogy) => (
                <AnalogyCard key={analogy.id} analogy={analogy} />
              ))}
            </div>
          </TabsContent>

          <TabsContent value="cc" className="mt-8">
            <div className="grid md:grid-cols-2 gap-6">
              {ccAnalogies.map((analogy) => (
                <AnalogyCard key={analogy.id} analogy={analogy} />
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Analogies;